import { render, staticRenderFns } from "./FormInputDatePicker.vue?vue&type=template&id=2025a4a7&"
import script from "./FormInputDatePicker.vue?vue&type=script&lang=js&"
export * from "./FormInputDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2025a4a7')) {
      api.createRecord('2025a4a7', component.options)
    } else {
      api.reload('2025a4a7', component.options)
    }
    module.hot.accept("./FormInputDatePicker.vue?vue&type=template&id=2025a4a7&", function () {
      api.rerender('2025a4a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputDatePicker.vue"
export default component.exports